import {ScrollTrigger} from "gsap/ScrollTrigger";
import {gsap} from "gsap";
import {smoothScrollPause, smoothScrollPlay} from "./scroll-smoother";
import {breakpointUp} from "./utils/breakpoints";
import {VideoPlayer} from "./parts/video-player";

gsap.config({nullTargetWarn:false});
jQuery(document).ready(function ($) {

  const $menuTrigger = $('.menu-trigger');

  // Select the close nav element
  const $closeNav = $('.js--menu-close');

  // Select the open-nav-container element
  const $openNavContainer = $('.open-nav-container');

  const navSmallVideoPlayer = new VideoPlayer('.nav-small-video')

  ScrollTrigger.create({
    trigger: '#smooth-wrapper',
    scrub: true,
    start: 'top-=10000vh top',
    endTrigger: 'footer',
    end: 'bottom+=30000vh',
    pin: '.navigation',
    markers: false,
    pinReparent: true,
    pinSpacing: false,
    pinType: 'fixed',
    zIndex: 99,
  });

  window.animateLogoInNavigation();


  function animateLinks() {
    gsap.fromTo(
      '.nav-grid .single-parent .single', // Target all elements with class .single
      {y: '100%', opacity: 0}, // Initial position (off-screen)
      {
        y: '0%', // Final position (on-screen)
        opacity: 1,
        duration: 0.5,
        ease: 'power2.inOut',
        stagger: 0.1, // Stagger the animation for each element
        delay: 0.1,
      }
    );
  }

  function animateVideo() {
    gsap.fromTo(
      '.nav-grid .video', // Target all elements with class .single
      {opacity: '0%'}, // Initial position (off-screen)
      {
        opacity: '100%', // Final position (on-screen)
        duration: 0.5,
        ease: 'power2.inOut',
        stagger: 0.1, // Stagger the animation for each element
        delay: 0.5,

      }
    );
  }

  function animateDivider() {
    gsap.fromTo(
      '.nav-grid .nav-divider', // Target all elements with class .single
      {width: '0%'}, // Initial position (off-screen)
      {
        width: '100%', // Final position (on-screen)
        duration: 0.5,
        ease: 'power2.inOut',
        stagger: 0.1, // Stagger the animation for each element
        delay: 0.8,

      }
    );
  }

  function animateSocials() {
    gsap.fromTo(
      '.nav-grid .info-layout .info-animate', // Target all elements with class .single
      {opacity: '0%', y: "30%"}, // Initial position (off-screen)
      {
        opacity: '100%', // Final position (on-screen)
        y: '0', // Final position (on-screen)
        duration: 0.5,
        ease: 'power2.inOut',
        stagger: 0.1, // Stagger the animation for each element
        delay: 0.6,
      }
    );
  }


  function openNav() {
    $openNavContainer.removeClass('d-none')
    $('.nav-grid').css('opacity', 1);
    $('html').addClass('overflow-hidden');
    $('body').addClass('overflow-hidden');
    smoothScrollPause();
    gsap.to($openNavContainer, {
      clipPath: 'inset(0% 0% 0%)',
      pointerEvents: 'all',
      duration: 0.5,
      ease: 'power2.inOut',
    });
    animateLinks()
    animateDivider()
    animateVideo()
    animateSocials()
    $('.open-nav-container video')[0].play();  }

  // Function to close the navigation
  function closeNav() {
    $('html').removeClass('overflow-hidden');
    $('body').removeClass('overflow-hidden');
    smoothScrollPlay();
    $('.open-nav-container video')[0].pause();
    gsap.to($openNavContainer, {
      clipPath: 'inset(0% 0% 100%)',
      pointerEvents: 'none',
      duration: 0.3,
      ease: 'power2.inOut',
      onComplete: () => {
        $openNavContainer.addClass('d-none')
      }
    });

  }

  // Add click event handler to the menu trigger to open the navigation
  $menuTrigger.click(openNav);

  // Add click event handler to the close nav element to close the navigation
  $closeNav.click(closeNav);

  $('.js--lang-switcher').click(function (event) {
    $(this).addClass('active-dropdown');
    // Prevent the event from propagating to document
    event.stopPropagation();
    // Toggle the display of lang-switcher-inner
    $('.lang-switcher-inner').toggle();

    if ($(this).hasClass('js--modal-open-sound')) {
      return
    }
    $("#hoverSound")[0].currentTime = 0;
    $("#hoverSound")[0].play();
  });

  // Click event on document to hide lang-switcher-inner when clicked outside
  $(document).click(function (event) {
    // Check if the clicked element is not inside lang-switcher
    if (!$(event.target).closest('.js--lang-switcher').length) {
      $('.js--lang-switcher').removeClass('active-dropdown');
      // Hide lang-switcher-inner
      $('.lang-switcher-inner').hide();
    }
  });


});
let navAnimationScene;

window.animateLogoInNavigation = () => {

  const clearLogoAnimation = () => {

    if (navAnimationScene) {
      navAnimationScene.getChildren().forEach(tween => {
        if (tween.vars.from && tween.vars.to) {
          tween.vars.from = null;
          tween.vars.to = null;
        }
      });

      navAnimationScene.kill();
      navAnimationScene = null;
    }
  }
  clearLogoAnimation();

  if ($('.block-index-hero').length && $(window).width() >= 1280) {
    navAnimationScene = gsap.timeline({
      scrollTrigger: {
        trigger: "#smooth-wrapper",
        start: "top top",
        end: `+=${82}`,
        scrub: true,
        pin: false,
        onEnter: function () {
          $('.navigation').removeClass('finished-scroll');
        },
        onLeave: function () {
          $('.navigation').addClass('finished-scroll');
        }

      },
    })
      .fromTo(".navigation",
        {height: '12.938rem', maxHeight: '12.938rem'},
        {height: '5.125rem', maxHeight: '5.125rem'})
      .fromTo(".nav-index-spacer",
        {height: '7.313rem'},
        {height: 0}, 0)
      .fromTo(".block-index-hero",
        {paddingTop: '12.938rem'},
        {paddingTop: '12.938rem'}, 0)
      .fromTo(".navigation .logo",
        {top: '-45%', width: '100%', padding: '0 5.5vw'},
        {top: '50%', padding: 0, width: '14.25rem'}, 0);

  }
}
